import { TableColumnList } from "../shared/table/table.component";

export const ORS_APPROVAL_TABLE_COLUMN: TableColumnList[] = [
  {
    name: "Requested by",
    key: "createdBy",
    width: "243px",
    type: "text",
    // iconUrl: "assets/images/info-line.svg",
    avatarKey: "profilePic",
  },
  {
    name: "Org Name",
    key: "orgName",
    width: "356px",
    type: "text",
    // iconUrl: "assets/images/info-line.svg",
    event: "view-org-details",
  },
  { name: "Org Type", key: "orgType", width: "111px", type: "text" },
  {
    name: "APPROVAL STATUS",
    key: "reviewStatus",
    width: "193px",
    type: "text",
  },
  { name: "Request Date", key: "createdAt", width: "139px", type: "text" },
];

export enum ChipType {
  gray = "gray",
  success = "success",
  warning = "warning",
  error = "error",
}
